import curry from "./curry.js";

export default curry(function equals2(a, b) {
  return a == b;
})